import { speedy } from "glamor";

if (process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== "test") {
    // force disable glamor's speedy mode which breaks DTS page editor
    speedy(false);
}
